import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { Component, AfterContentInit, OnDestroy, ElementRef, Input } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { TranslateService } from '@ngx-translate/core';
import { ActionDefinitionDTO, LicenseDTO } from '../../api/plyca-dtos-v2';
import { PaginationDTO } from '../../api/PaginationModel';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { Configuration } from '../../conf/app.constants';
import { LicensePanelAdminComponent } from './licensePanelAdmin.component';
import { ActionService } from '../../actions/action.service';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { ActionDTO } from '../../api/plyca-dtos';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';


@Component({
  selector: 'licensePanel',
  templateUrl: 'licensePanel.template.html',
  providers: [DialogService]
})
export class licensePanelComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  loaded = false;

  @Input() parentElement: any;
  licenses: LicenseDTO[];
  licensesNoActive: LicenseDTO[] = [];
  activeLicense: LicenseDTO;
  hostNameActive: string;
  numInvitsAllowed: string;
  numUsersActive: string;
  actions: ActionDefinitionDTO[];


  constructor(
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    public uiService: UIService,
    public dialogService: DialogService,
    public actionService: ActionService,
    public translate: TranslateService,
    private headerActionsService: HeaderActionsService,
    protected configuration: Configuration,
    private plycaErrorHandler: PlycaErrorHandler,
    private elem: ElementRef
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.LICENSE));
    this.setHostNameActive();
    this.setNumUsersActive();
    this.setNumInvitsAllowed();

  }

  ngAfterContentInit(): void {

    if (this.parentElement == null)
      this.parentElement = this.elem;

    this.loadConfig();
    this.loadLicenses();
  }

  loadHeaders(): void {

    this.headerActionsService.setTaskDescription(this.elem, 'License.title', 'far fa-registered', this.isLoaded.bind(this));
    this.subscribe(
      this.headerActionsService.addAction(
        'License.new',
        'fas fa-plus',
        'btn-secondary',
        true
      ), success => {
        this.addLicense()
      });


    if (this.actions) {
      this.actions.forEach(action => {
        this.subscribe(
          this.headerActionsService.addAction(
            action.name,
            this.actionService.getActionIconClass(action.executableAction),
            'btn-secondary',
            true
          ), success => {

            this.subscribe(
              this.openModal(action.executableAction).onClose

              , () => this.loadLicenses());
          });
      });
    }

    this.subscribe(
      this.headerActionsService.addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ), success => {
        this.uiService.routeBack();
      });



  }

  openModal(action: ActionDTO) {

    let config: DynamicDialogConfig = {
      header: action.name,

      width: '70%',
      styleClass: 'actionStyle'

    };
    config['action'] = action;
    //config['obj'] = obj;

    return this.dialogService.open(ActionsProcessComponent, config);


  }

  loadConfig(): void {
    this.subscribe(
      this.plycaService.getAction('RELOAD_LICENSE'), (datos: any) => {
        this.actions = null;
        if (datos && datos.content) {
          this.actions = datos.content;
        }
        this.loadHeaders();
      });
  }



  ngOnDestroy() {
    this.dialogService = null;
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  public setHostNameActive(): void {
    this.subscribe(
      this.plycaService
        .getLicenseHostNameActive()
      , (result: string) => {
        if (result) {
          this.hostNameActive = result;
        }
      });
  }

  public setNumInvitsAllowed(): void {
    this.subscribe(
      this.plycaService
        .getLicenseNumInvitsAllowed()
      , (result: string) => {
        if (result) {
          this.numInvitsAllowed = result;
        }
      });
  }

  public setNumUsersActive(): void {
    this.subscribe(
      this.plycaService
        .getLicenseNumUsersActive()
      , (result: string) => {
        if (result) {
          this.numUsersActive = result;
        }
      });
  }

  remove(row: LicenseDTO) {
    this.uiService.showConfirmMessage({
      message: this.translate.instant('General.confirm.action.delete'),
      header: this.translate.instant('General.confirm.text'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscribe(
          this.plycaService.delete(this.configuration.LICENSE_PLATFORM_SERVICE_URL, row.identifier),
          response => {
            this.loadLicenses();
          },
          err => {
            this.plycaErrorHandler.showServerError(err);
          }
        );
      },
      reject: () => {
        console.log('ELIMINACIÓN CANCELADA');
      }
    });
  }

  addLicense() {
    // this.openWindowCompany(new CompanyDTO(), true);
    let newLicense = new LicenseDTO();
    newLicense.identifier = 'new';

    //  this.openWindowLicense(newLicense, true);

    let config: DynamicDialogConfig = {
      header: this.translate.instant('License.addTitle'),
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition'

    };


    const ref = this.dialogService.open(
      LicensePanelAdminComponent,
      config
    );

    this.subscribe(
      ref.onClose, result => {

        this.loadLicenses();

      });



  }


  loadLicenses() {
    this.loaded = false;
    this.licensesNoActive = null;
    this.subscribe(
      this.plycaService
        .getLicenses()
      , (result: PaginationDTO<LicenseDTO>) => {
        if (result && result.content) {
          this.licenses = result.content;
          console.log(this.licenses);
          this.activeLicense = this.licenses.find(license => (license.active && license.valid));
          this.loadLicenseNoActive(this.activeLicense);
        } else {
          this.licenses = null;
          this.activeLicense = null;
          this.loadLicenseNoActive(this.activeLicense)
        }
        this.loaded = true;
      });
  }

  loadLicenseNoActive(activeLicense: LicenseDTO) {
    this.licensesNoActive = [];
    if (this.licenses != null) {
      let id: number;
      for (let i = 0; i < this.licenses.length; ++i) {
        if (!activeLicense || this.licenses[i].identifier != activeLicense.identifier) {
          this.licensesNoActive.push(this.licenses[i]);
        }
      }
    } else {
      this.licensesNoActive = null;
    }
  }



}
